import { useQuery } from '@tanstack/react-query'
import { SIP_PLANS_API_RETRY_COUNT, isSipQueryFetchFailed, isSipQueryLoading } from '../../api/queryOptions'
import { fetchSipIdealPlanRecommendation } from '../api/repository'
import type { SipIdealPlanRecommendationApiResponse } from '../api/idealRecommendation.types'
import { IdealSipPlanRecommendationSheet } from './IdealSipPlanRecommendationSheet'

const IDEAL_SIP_PLAN_RECOMMENDATION_QUERY_KEY = 'sip-plans-v4-ideal-recommendation'

export function IdealSipPlanRecommendationContainer(input: {
  onDismiss: () => void
  isin: string
  totalIdealSipAmount: number
}) {
  const { onDismiss, isin, totalIdealSipAmount } = input
  const { planDetails, isLoading, isFetchFailed, onRetry } = useIdealSipPlanRecommendation(
    isin,
    totalIdealSipAmount,
    true
  )

  return (
    <IdealSipPlanRecommendationSheet
      onDismiss={onDismiss}
      planDetails={planDetails}
      isLoading={isLoading}
      isFetchFailed={isFetchFailed}
      onRetry={onRetry}
    />
  )
}

function useIdealSipPlanRecommendation(
  isin: string,
  totalIdealSipAmount: number,
  enabled: boolean
): {
  planDetails: SipIdealPlanRecommendationApiResponse | null
  isLoading: boolean
  isFetchFailed: boolean
  onRetry: () => void
} {
  const query = useQuery({
    queryKey: [IDEAL_SIP_PLAN_RECOMMENDATION_QUERY_KEY, isin, totalIdealSipAmount],
    queryFn: () => fetchSipIdealPlanRecommendation(isin),
    enabled: enabled && isin.length > 0,
    retry: SIP_PLANS_API_RETRY_COUNT
  })

  return {
    planDetails: query.data ?? null,
    isLoading: isSipQueryLoading(query),
    isFetchFailed: isSipQueryFetchFailed(query),
    onRetry: () => {
      void query.refetch()
    }
  }
}
